import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

@Injectable()
export class API01V2RequestService {
    private readonly requestApiUrl: string = '/api/API01V2/request';
    private readonly requestApi01Url: string = '/api/API01/request';
    private creationPossibilityUrl: string = '/api/user-traits/creation-possibility/API01V2';

    constructor(private http: HttpClient) {}
    public post(editModel: Backend.EditAPI01V2RequestModel, saveAsDraft: boolean): Observable<CorrelationId> {
        return this.http.post<CorrelationId>(saveAsDraft ? `${this.requestApiUrl}/draft` : this.requestApiUrl, editModel);
    }

    public put(editModel: Backend.EditAPI01V2RequestModel, saveAsDraft: boolean): Observable<CorrelationId> {
        return this.http.put<CorrelationId>(saveAsDraft ? `${this.requestApiUrl}/draft` : this.requestApiUrl, editModel);
    }

    public getRequestState(id: string): Observable<RequestStateWithTraits<Backend.API01V2RequestState>> {
        return this.http.get<RequestStateWithTraits<Backend.API01V2RequestState>>(`${this.requestApiUrl}/${id}`);
    }

    public creationPossibilityRequest(): Observable<Object> {
        return this.http.get(this.creationPossibilityUrl);
    }

    public checkIsValidWebsiteUrl(siteUrl: string): Observable<Backend.ValidationState> {
        let params = new HttpParams();
        params = params.set('siteUrl', siteUrl);
        return this.http.get<Backend.ValidationState>('/api/API01V2/validations/site-validity', { params });
    }

    public cancelRequest(correlationId: string, reason: string): Observable<void> {
        return this.http.post<void>(`${this.requestApiUrl}/cancellation`, {
            correlationId,
            reason
        });
    }

    public takeStageToWorkRequest(stageToTake: Backend.TakeStageToWorkModel): Observable<HttpResponse<void>> {
        const url = `${this.requestApiUrl}/${stageToTake.correlationId}/lifetime/taking-to-work`;
        return this.http.post<HttpResponse<void>>(url, stageToTake);
    }

    public getAgencyOffices(): Observable<Backend.AgencyOfficeInfo[]> {
        return this.http.get<Backend.AgencyOfficeInfo[]>(`${this.requestApiUrl}/offices`);
    }

    public getBPCodeOfRequest(id: string): Observable<Backend.BusinessProcessType> {
        return this.http.get<Backend.BusinessProcessType>(`${this.requestApi01Url}/bp-code-of-request/${id}`);
    }

    public getActiveAgencyAgreement(agencyCode: string): Observable<Backend.AgentAgreementInfo> {
        return this.http.get<Backend.AgentAgreementInfo>(`${this.requestApiUrl}/active-agency-agreement/${agencyCode}`);
    }
    public getValidApiAgreements(agencyCode: string): Observable<Backend.AgentAgreementInfo[]> {
        return this.http.get<Backend.AgentAgreementInfo[]>(`${this.requestApiUrl}/valid-api-agreements/${agencyCode}`);
    }
    
    public getActiveSignatory(agencyCode: string): Observable<Backend.AgencyContactInfo> {
        return this.http.get<Backend.AgencyContactInfo>(`${this.requestApiUrl}/agency-active-signatory/${agencyCode}`);
    }

    public getCarriers(): Observable<Backend.CarrierModel[]> {
        return this.http.get<Backend.CarrierModel[]>(`${this.requestApiUrl}/carriers`);
    }

    public getDocsBoxSignatories(): Observable<Backend.SignerInfo[]> {
        return this.http.get<Backend.SignerInfo[]>(`${this.requestApiUrl}/docsbox-signatories`);
    }

    public checkAgencyHasValidApiAgreement(agencyCode: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.requestApiUrl}/agency-valid-api-agreement/${agencyCode}`);
    }

    public getActiveAA03Requests(agencyCode: string): Observable<Backend.ActiveRequest[]> {
        return this.http.get<Backend.ActiveRequest[]>(`${this.requestApiUrl}/active-aa03-requests/${agencyCode}`);
    }
}


